export default {"src":"/_next/static/media/rating-4.5.1d5fa612.svg","height":47,"width":222,"blurWidth":0,"blurHeight":0};